import React, { useId } from "react";

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
}

const Select: React.FC<SelectProps> = ({ label, value, onChange, options, placeholder = "Select...", error, required = false, disabled = false }) => {
  const id = useId();
  const labelSt: React.CSSProperties = { fontSize: "12px", fontWeight: 500, color: "var(--t2, #5A6178)", fontFamily: "var(--font-primary, DM Sans, sans-serif)", lineHeight: "16px" };
  const selectSt: React.CSSProperties = { fontSize: "13px", fontFamily: "var(--font-primary, DM Sans, sans-serif)", color: value ? "var(--t1, #1A1D2E)" : "var(--t3, #9CA3B8)", backgroundColor: disabled ? "var(--hover, #F0F1F5)" : "var(--surface, #FFFFFF)", border: error ? "1px solid var(--red, #E5484D)" : "1px solid var(--card-border, #E2E5EC)", borderRadius: "8px", padding: "10px 14px", outline: "none", width: "100%", boxSizing: "border-box" as const, transition: "border-color 0.15s ease, box-shadow 0.15s ease", cursor: disabled ? "not-allowed" : "pointer", appearance: "none" as const, backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath d=%27M3 4.5L6 7.5L9 4.5%27 fill=%27none%27 stroke=%27%239CA3B8%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E\")", backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center", paddingRight: "36px" };
  const errSt: React.CSSProperties = { fontSize: "11px", fontWeight: 500, color: "var(--red, #E5484D)", margin: 0, marginTop: "4px" };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px", width: "100%" }}>
      <label htmlFor={id} style={labelSt}>
        {label}
        {required && <span style={{ color: "var(--accent, #D23A3B)", marginLeft: "2px" }}>*</span>}
      </label>
      <select id={id} value={value} onChange={(e) => onChange(e.target.value)} disabled={disabled} required={required} style={selectSt} onFocus={(e) => { if (!error) { e.currentTarget.style.borderColor = "var(--accent, #D23A3B)"; e.currentTarget.style.boxShadow = "0 0 0 3px var(--accent-soft, rgba(210, 58, 59, 0.1))"; } }} onBlur={(e) => { if (!error) { e.currentTarget.style.borderColor = "var(--card-border, #E2E5EC)"; e.currentTarget.style.boxShadow = "none"; } }}>
        {placeholder && <option value="" disabled>{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {error && <p style={errSt}>{error}</p>}
    </div>
  );
};

export default Select;
